import { useQuery } from '@tanstack/react-query';

import { api } from 'constants/api';
import { ApiResponse } from 'types/utils/api-response';

export type ApiConfigurationType = {
  braze_api_key: string;
  api_key: string;
};

export type ApiConfigurationResponseType = ApiConfigurationType;

export const useGetApiConfiguration = () => {
  return useQuery({
    queryKey: ['getApiKey'],
    enabled: true,
    queryFn: async () => {
      const { data } =
        await api.get<ApiResponse<ApiConfigurationResponseType>>('/configuration');

      return data?.data;
    },
  });
};
